export const BASE_URL_HTTP = `${process.env.REACT_APP_API_TYPE}${process.env.REACT_APP_API_URL}`
